import React from 'react';

import { User } from '@project44/ui-utils';
import { SharedModels } from '@project44-models/iam-gateway';

import { ReactComponent } from '../../../../../shared/abstract/infrastructrue/ReactComponent';
import {
  TAssignedUserTenantAgnosticRolesState,
  TUIUserTenantAgnosticRoles,
  TUserTenantAgnosticRolesCheckbox,
} from '../../../domain/interfaces';
import { UserTenantAgnosticRolesCheckbox as Checkbox } from './UserTenantAgnosticRolesCheckbox.view';

export interface IUserTenantAgnosticRolesCheckboxCreator {
  isApiRequestInProgress: boolean;
  userPrincipal: User;
  unifiedRole: SharedModels.UnifiedRoleViewModel;
  assignedUserTenantAgnosticRolesState: TAssignedUserTenantAgnosticRolesState;
  uiUserTenantAgnosticRoles: TUIUserTenantAgnosticRoles;
}

export class UserTenantAgnosticRolesCheckbox extends ReactComponent {
  public static create({
    isApiRequestInProgress,
    userPrincipal,
    unifiedRole,
    assignedUserTenantAgnosticRolesState,
    uiUserTenantAgnosticRoles,
  }: IUserTenantAgnosticRolesCheckboxCreator): React.ReactElement<TUserTenantAgnosticRolesCheckbox> {
    const {
      userTenantAgnosticRolesEditor: {
        canUserPrincipalUpdateTenantAgnosticUnifiedRoles,
        addUnifiedRole,
        removeUnifiedRole,
      },
    } = uiUserTenantAgnosticRoles;

    const isEditableByUserPrincipal =
      canUserPrincipalUpdateTenantAgnosticUnifiedRoles(userPrincipal);

    const withLoadingStatus: React.FC<TUserTenantAgnosticRolesCheckbox> =
      this.composeWithLoadingStatus<TUserTenantAgnosticRolesCheckbox>(
        Checkbox,
        {
          withLoadingStatusOptions: {
            isLoading: isApiRequestInProgress,
            css: {
              h: '21px',
              w: '21px',
            },
          },
        },
      );

    return this.withAnyOfPermissionsHOC<TUserTenantAgnosticRolesCheckbox>(
      ['system-admin:read:tenant-agnostic-user-role-assignments'],
      withLoadingStatus,
      {
        user: userPrincipal,
        handleAddRole: addUnifiedRole,
        handleRemoveRole: removeUnifiedRole,
        isApiRequestInProgress,
        unifiedRole,
        assignedUserTenantAgnosticRolesState,
        isEditableByUserPrincipal,
      },
    );
  }
}
